<template>
  <v-dialog
    :value="value"
    max-width="450"
    :persistent="persistent"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title class="text-h5">{{ title }}</v-card-title>
      
      <v-card-text>{{ message }}</v-card-text>

      <v-card-actions class="shaded-light">
        <v-spacer />
        <v-btn color="primary" small @click="reloadPage">Reload Page</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },

    title: {
      type: String,
      default: 'Session Timeout',
    },
    
    message: {
      type: String,
      default: 'This page has been open for a while and is no longer receiving live updates. Please reload the page to continue.',
    },

    persistent: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    reloadPage() {
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }
      window.location.reload(true);
    },
  },
};
</script>